import { theme } from 'styled-tools';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import BaseContainer from '@mui/material/Container';

export const Container = styled(BaseContainer)`
  border-bottom: ${props => props.hasBorder ? '0.0625rem solid ' + theme('colors.borderGray') : 'none'};
`;

export const GridContainer = styled(Grid)`
  flex-direction: column;
  flex-wrap: nowrap;

  ${props => props.theme.breakpoints.up('md')} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 1.25rem;
  display: flex;
  width: 70%;

  .MuiButton-root > * {
    font-size: 0.875rem;
  }

  ${props => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
    width: 100%;
  }
`;
